import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';
import { shiftsDelete } from '~/generated';
import { extractData } from '~/utils/query-utils';

export const useDeleteShift = (
  options: UseMutationOptions<void, unknown, { id: number }, unknown> = {}
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id }) =>
      extractData(
        shiftsDelete({
          path: { id },
        })
      ),
    ...options,
    onSuccess(data, variables, mutationResult, context) {
      queryClient.invalidateQueries({
        queryKey: ['shifts', variables.id],
      });
      options.onSuccess?.(data, variables, mutationResult, context);
    },
  });
};
